<template>
  <div>
    <success :show-promotes='false' v-if='isZoomSchedulerFreeTrial'>
      <thanks :email='email' :title='title'>
        <subtitle :sub-title="$t('billing.trial.trial_auto_assign_subtitle', [this.buyTrialPlanName])" />
        <zm-button
          target='_blank'
          round
          type='primary'
          :href='schedulerLink'
          @click='goFreeTrialTracking'
          class='text-capitalize'>
          {{ $t('billing.trial.start_free_trial_btn', [buyTrialPlanName]) }}
        </zm-button>
        <download-action />
      </thanks>
    </success>
    <CommonAddon v-else />
  </div>
</template>

<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import { planTypes } from '@/common/constants';
import QueryString from 'qs';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { flowTypes } from '@/common/service/page-config';
import DownloadAction from '@/views/succezz/thanks-template/download-action.vue';
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import { ZOOM_SCHEDULER_ORIGIN, displayPlanNamesMap } from '@/views/success/index.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import common from '@/views/succezz/mixin/common';

export default {
  mixins: [common],
  components: {
    Subtitle,
    Thanks, Success, DownloadAction,
    CommonAddon,
  },
  data() {
    return {
      schedulerLink: ZOOM_SCHEDULER_ORIGIN,
    };
  },
  computed: {
    isZoomSchedulerFreeTrial() {
      return this.isBuyTrialFlow && this.buyTrialPlan === planTypes.ZOOM_SCHEDULER;
    },
    buyTrialPlanName() {
      return this.$t(displayPlanNamesMap[this.buyTrialPlan]) || '';
    },
    buyTrialPlan() {
      const query = QueryString.parse(location.search.slice(1));
      const { from: successPlanCode = '' } = query || {};
      return getPlanTypeByCategory(successPlanCode) || '';
    },
    isBuyTrialFlow() {
      const query = QueryString.parse(location.search.slice(1));
      const { type: successFlowType = '' } = query || {};
      return successFlowType === flowTypes.buyTrial;
    },
  },
  methods: {
    goFreeTrialTracking() {
      this.$tracking.postPurchase(this.isZoomSchedulerFreeTrial ? `set up Scheduler` : `start free trial`);
    },
  },
};
</script>
